import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { Pagination } from '@mode/shared/contract-common';
import { PaginatorComponent } from '../paginator/paginator.component';

interface PaginationViewModel {
  currentPage: number;
  pageCount: number;
  pageItemRangeStart: number;
  pageItemRangeEnd: number;
  itemTotal: number;
}

@Component({
  selector: 'mode-pagination-view',
  standalone: true,
  imports: [CommonModule, PaginatorComponent],
  templateUrl: './pagination-view.component.html',
  styleUrls: ['./pagination-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginationViewComponent implements OnChanges {
  public vm$ = new BehaviorSubject<PaginationViewModel | null>(null);

  @Input() pagination: Pagination | null = null;
  @Input() paginationStyle: 'button' | 'link' = 'link';
  @Output() currentPageChange = new EventEmitter<number>();

  ngOnChanges({ pagination }: SimpleChanges) {
    if (pagination) {
      this.updateModel(pagination.currentValue);
    }
  }

  updateModel(pagination: Pagination | null) {
    if (!pagination) return;

    this.vm$.next({
      currentPage: pagination.page,
      pageCount: pagination.total_pages || 0,
      pageItemRangeStart: (pagination.page - 1) * pagination.per_page + 1,
      pageItemRangeEnd:
        pagination.page * pagination.per_page > pagination.total_count
          ? pagination.total_count
          : pagination.page * pagination.per_page,
      itemTotal: pagination.total_count,
    });
  }

  handleChangeCurrentPage(pageNum: number) {
    this.currentPageChange.next(pageNum);
  }
}
